/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetGlycerinDisplayProductPayloadFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetGlycerinDisplayProductPayloadFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import {
  getGetGlycerinAvailabilityFragmentedData,
  getGlycerinAvailabilityReturnMock,
} from '../getGlycerinAvailability/mockdata';
import {
  getGlycerinServicesCurrencyDataMock,
  getGlycerinServicesDataMock,
  getGlycerinServicesReturnMock,
} from '../getGlycerinServices/mockdata';
import { getGlycerinPriceDataMock, getGlycerinPriceReturnMock } from '../getGlycerinPrice/mockdata';
import {
  getGlycerinRatingStatusDataMock,
  getGlycerinRatingStatusReturnMock,
} from '../getGlycerinRatingStatus/mockdata';
import {
  getGetStockValuesFromDimensionsFragmentedData,
  getStockValuesFromDimensionsResultMock,
} from '../getStockValuesFromDimensions/mockdata';

import type { getGlycerinDisplayProductPayload } from '.';
import { getGlycerinOriginReturnMock } from '../getGlycerinOrigin/mockdata';

export const getGlycerinDisplayProductPayloadDataMock: GetGlycerinDisplayProductPayloadFragmentFragment =
  {
    akl: 'AKLBB761176388',
    sku: '9669202279-40-761176388',
    orderNumber: '96692022',
    availability: getGetGlycerinAvailabilityFragmentedData(),
    price: { ...getGlycerinPriceDataMock, ...getGlycerinServicesCurrencyDataMock },
    seoRatingGetGlycerinDisplayProductPayload: getGlycerinRatingStatusDataMock,
    aplusGetGlycerinDisplayProductPayload: getGlycerinServicesDataMock,
    ...getGetStockValuesFromDimensionsFragmentedData(),
  };

export const getGlycerinDisplayProductPayloadReturnMock: ReturnType<
  typeof getGlycerinDisplayProductPayload
> = {
  productId: getGlycerinDisplayProductPayloadDataMock.akl,
  articleId: getGlycerinDisplayProductPayloadDataMock.orderNumber,
  skuId: getGlycerinDisplayProductPayloadDataMock.sku,
  ...getGlycerinPriceReturnMock,
  ...getGlycerinAvailabilityReturnMock,
  ...getGlycerinRatingStatusReturnMock,
  ...getGlycerinOriginReturnMock,
  ...getGlycerinServicesReturnMock,
  variantsInStock: getStockValuesFromDimensionsResultMock.inStock,
  variantsOutOfStock: getStockValuesFromDimensionsResultMock.outOfStock,
};

export function getGetGlycerinDisplayProductPayloadFragmentedData(
  data?: GetGlycerinDisplayProductPayloadFragmentFragment,
) {
  return makeFragmentData(
    data || getGlycerinDisplayProductPayloadDataMock,
    GetGlycerinDisplayProductPayloadFragmentFragmentDoc,
  );
}
